import React from 'react'
import HeaderLeftUI from './HeaderLeftUI'
import SuperUserHeaderRightUI from './SuperUserHeaderRightUI'
import SuperUserFooterUI from './SuperUserFooterUI'
import PageUI from './PageUI'

const SuperUserPageUI = ({ context, className, topnav,
  // page params
  backLink, headerText, subHeaderText, onToggleSidebar, showSidebar,
  // content params
  dimension, centered, children, sideBar, account, loan,
  //
  showStp, onShowStpClick, onTypeChange
}) =>
  <PageUI
    context={context}
    className={className}
    dimension={dimension}
    centered={centered}
    children={children}
    sideBar={sideBar}
    showSidebar={showSidebar}
    headerLeft={
      <HeaderLeftUI
        context={context}
        backLink={backLink}
        headerText={headerText}
        subHeaderText={subHeaderText}
        onToggleSidebar={onToggleSidebar}
        account={account}
        loan={loan}
      />
    }
    headerRight={
      <SuperUserHeaderRightUI context={context} topnav={topnav}
        showStp={showStp} onShowStpClick={onShowStpClick} 
        onTypeChange={onTypeChange}
      />
    }
    footer={
      <SuperUserFooterUI context={context} topnav={topnav} />
    }
  />

export default SuperUserPageUI
